//** Import Modules */
import ContentPageTitle from "../../../common/ContentPageTitle";
import StyledQRCode from "../components/StyledQRCode";
import { useEffect, useState } from "react";
import { FE_URL } from "../../../common/constants";

export default function BusinessProfile(props) {
  const { business } = props;

  const [profileURL, setProfileURL] = useState("");

  useEffect(() => {
    if (business.meta_data && business.meta_data.length > 0) {
      const getProfileHandle = business.meta_data.filter(
        (b) => b.meta_key === "business_handle"
      )[0];

      if (getProfileHandle !== undefined) {
        const profileURL = `${FE_URL}/business/${getProfileHandle.meta_value}`;

        setProfileURL(profileURL);
      }
    }
  }, [business]);

  return (
    <div id="business-settings">
      <div className="content-box">
        <ContentPageTitle title="Business QR" icon="briefcase" />
        <StyledQRCode url={profileURL} />
      </div>
    </div>
  );
}
